<div class="ds-dashboard-layout" id="chat-windowTag">
    <div class="ds-chat-main-area is-mobile-visible">
        <!-- Active Chat: Modernized Structure from MessagesComponent -->
        <div class="message-box" id="message-box">
            <div class="chat-header">
                <div class="header-left">
                    <div class="avatar-circle header-avatar shadow-sm" >
                        {{getInitials(selectedFriend?.firstname, selectedFriend?.lastname)}}
                    </div>
                    <div class="chat-about">
                        <h6 [attr.title]="selectedFriendName">{{selectedFriendName || ''}}</h6>
                        <div class="header-metadata-row">
                            
                            <!-- Assign / Claim badges for Admin -->
                            <!-- <div *ngIf="_auth.getUsertype() == 'Admin'" class="header-assignment-area">
                                <button *ngIf="selectedFriend && !selectedFriend.assigned_admin_id" (click)="assignCustomer(selectedFriend.id)" class="btn-claim-header">
                                    <i class="fa fa-hand-o-right"></i> <span>Claim Customer</span>
                                </button>
                                <span *ngIf="selectedFriend && selectedFriend.assigned_admin_id == UserId" class="badge-assigned-header" (click)="unassignCustomer(selectedFriend.id)">
                                    <i class="fa fa-check-circle"></i> Assigned to You <i class="fa fa-times"></i>
                                </span>
                            </div> -->
                            
                            <div class="header-snooze-info" *ngIf="snoozedataobj.snoozed_until && getMessageWidth() =='admin'">
                                <div class="metadata-separator">•</div>
                                <span class="badge-snooze-header">
                                    <i class="fa fa-clock-o"></i> Snoozed until {{DateFormat(snoozedataobj.snoozed_until)}}
                                </span>
                                <button class="btn-remove-snooze-header" (click)="confirmRemoveSnooze()">
                                    <i class="fa fa-trash-o"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            
                <div class="header-right" style="display: flex; align-items: center; gap: 12px; flex-shrink: 0;">
                    <!-- Chat Search Toggle -->
                    <button class="btn-chat-search-toggle" (click)="toggleChatSearch()" [class.active]="isChatSearchVisible" title="Search in chat">
                        <i class="fa" [ngClass]="isChatSearchVisible ? 'fa-times' : 'fa-search'"></i>
                    </button>

                    <div class="dropdown" *ngIf="enablesnooze && !snoozedataobj.snoozed_until && getMessageWidth() =='admin'">
                        <button class="btn btn-sm" style="background: #EBF5FF; color: #1877F2; border: none; font-weight: 800; border-radius: 12px; padding: 10px 20px; display: flex; align-items: center; gap: 8px;" type="button" data-bs-toggle="dropdown" data-bs-boundary="viewport">
                            Snooze <i class="fa fa-angle-down"></i>
                        </button>
                        <ul class="dropdown-menu dropdown-menu-end shadow-lg" style="border-radius: 16px; border: 1px solid #F1F5F9; padding: 8px;">
                            <div class="dropdown-header" style="font-weight: 800; font-size: 11px; text-transform: uppercase; color: #94A3B8; padding: 12px 16px;">Snooze Until...</div>
                            <li *ngIf="showSnoozeLastDayOption"><a class="dropdown-item" (click)="snoozeChat('latertoday')" style="border-radius: 10px; padding: 10px 16px; font-weight: 600;"><i class="fa fa-moon-o mr-2" style="color: #6366F1;"></i> Later Today {{ GetSnoozedateoption('later') }} PM</a></li>
                            <li><a class="dropdown-item" (click)="snoozeChat('tomorrow')" style="border-radius: 10px; padding: 10px 16px; font-weight: 600;"><i class="fa fa-sun-o mr-2" style="color: #F59E0B;"></i> Tomorrow {{ GetSnoozedateoption('Tomorrow') }} AM</a></li>
                            <li><a class="dropdown-item" (click)="snoozeChat('pickdatetime')" style="border-radius: 10px; padding: 10px 16px; font-weight: 600;"><i class="fa fa-calendar mr-2" style="color: #10B981;"></i> Pick Date & Time</a></li>
                        </ul>
                    </div>
                    <button class="btn btn-sm btn-danger" *ngIf="convertbtn_id && adminnotconnect === 0" (click)="endChatConfirm()" style="border-radius: 12px; font-weight: 800; padding: 10px 20px;">
                       End
                    </button>
                </div>
            </div>

            <!-- Expandable Chat Search Bar -->
            <div class="chat-search-container" [class.is-visible]="isChatSearchVisible">
                <div class="chat-search-inner">
                    <i class="fa fa-search"></i>
                    <input type="text" [(ngModel)]="chatSearchQuery" placeholder="Search in this conversation..." autocomplete="off" />
                    <button class="btn-clear-search" *ngIf="chatSearchQuery" (click)="clearChatSearch()">
                        <i class="fa fa-times-circle"></i>
                    </button>
                </div>
            </div>

            <div class="msg-space" id="users-conversation" [ngClass]="{'is-admin-view': _auth.getUsertype() == 'Admin'}" (scroll)="onScroll($event)" style="padding: 24px; background: #F8FAFC;">
                <div class="chat-bubbles-container">
                    <div *ngFor="let item of filteredMessages; let i = index" style="width: 100%;">
                        <div class="msgdate"><span>{{todayString(item.date, 'chat')}}</span></div>

                        <div *ngFor="let messagePacket of item.data" [id]="messagePacket.id" 

                            class="message-packet" [ngClass]="alignMessage(messagePacket.type) ? 'is-other' : 'is-me'">
                                                    
                            <div class="sender-name-label" [innerHTML]="messagePacket.firstname | highlight: chatSearchQuery"></div>

                            <div class="bubble-common" [ngClass]="alignMessage(messagePacket.type) ? 'other-message' : 'my-message'">
                                <span [innerHTML]="messagePacket.message | highlight: chatSearchQuery"></span>
                                <div class="msg-inner-meta">
                                    <span class="msg-time">{{messagePacket.mtime}}</span>
                                    <div class="bubble-ticks" *ngIf="messagePacket.fromUserId == UserId" style="display: flex; align-items: center; margin-left: 2px;">
                                        <svg class="tick-icon sent" *ngIf="messagePacket.status == 1 && messagePacket.endsess != 2" viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                                            <polyline points="20 6 9 17 4 12"></polyline>
                                        </svg>
                                        <svg class="tick-icon read" *ngIf="messagePacket.status == 0 && messagePacket.endsess != 2" viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                                            <polyline points="18 6 7 17 2 12"></polyline>
                                            <path d="M22 6L12 16"></path>
                                        </svg>
                                        <svg class="tick-icon ended" *ngIf="messagePacket.endsess == 2" viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="#FCA5A5" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                                            <polyline points="20 6 9 17 4 12"></polyline>
                                        </svg>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="ds-status-banner-container" *ngIf="msgType === 1 && adminnotconnect === 1&&(!isCutoffTime && _auth.getUsertype() != 'Admin')">
                        <div class="ds-status-banner is-waiting">
                            <i class="fa fa-spinner fa-spin"></i>
                            We'll connect you with a teller shortly.
                        </div>
                    </div>

                    <div class="ds-status-banner-container" *ngIf="endsess == 0">
                        <div class="ds-status-banner">
                            <i class="fa fa-info-circle"></i>
                            This chat session has ended.
                        </div>
                    </div>
                </div>
            </div>

            <!-- Floating Scroll-to-Bottom Button -->
            <button class="scroll-bottom-btn" [ngClass]="{'is-visible': showScrollToBottom}" (click)="scrollToBottomClicked()">
                <i class="fa fa-arrow-down"></i>
            </button>

            <div class="chat-message" style="background: #fff; border-top: 1px solid #F1F5F9; border-radius: 0 0 24px 24px;">
              

                <!-- Cutoff Alert -->
                <div class="cutoff-alert-wrapper" *ngIf="isCutoffTime&& _auth.getUsertype() != 'Admin'">
                    <div class="cutoff-alert">
                        <div class="cutoff-icon">
                            <i class="fa fa-clock-o"></i>
                        </div>
                        <div class="cutoff-message">
                            <h4>Currently Unavailable</h4>
                            <p>Our tellers are currently unavailable. We will respond to your message during the next business day.</p>
                        </div>
                    </div>
                </div>
                  <div class="premium-composer-wrapper">

                    <!-- File Upload Option (Visible only for Customers) -->
                    <div class="composer-actions" *ngIf="_auth.getUsertype() != 'Admin'">
                        <button class="btn-attach" (click)="fileInput.click()" title="Attach a file">
                            <i class="fa fa-paperclip"></i>
                        </button>
                        <input #fileInput type="file" (change)="onFileSelected($event)" style="display: none;" accept=".jpeg,.jpg,.png,.pdf" />
                    </div>

                    <div class="composer-content-area" style="flex: 1; display: flex; flex-direction: column; min-width: 0;">
                        <!-- Selected File Preview -->
                        <div class="selected-file-preview" *ngIf="selectedFile">
                            <i class="fa" [ngClass]="selectedFile.type.includes('pdf') ? 'fa-file-pdf-o' : 'fa-file-image-o'"></i>
                            <span class="file-name">{{selectedFile.name}}</span>
                            <button class="btn-remove-file" (click)="clearSelectedFile()">
                                <i class="fa fa-times"></i>
                            </button>
                        </div>
                        
                        <textarea class="composer-input" placeholder="{{selectedFile ? 'File selected. Send it now!' : 'Type a message...'}}" id="message" name="message" 
                            [value]="message" (input)="message=$any($event.target).value" (keyup.enter)="sendMessageClick()" autocomplete="off"
                            [disabled]="selectedFile || isSending"></textarea>
                    </div>

                    <button class="premium-send-btn" [class.is-sending-mode]="isSending" (click)="sendMessageClick()" [disabled]="((!message || message.trim() == '') && !selectedFile) || isSending">
                    
                        <span *ngIf="isSending">Sending...</span>
                        <i *ngIf="!isSending" class="fa fa-paper-plane"></i>
                        <i *ngIf="isSending" class="fa fa-spinner fa-spin"></i>
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- MODALS REFINED (Synced with Dashboard) -->
<!-- End Chat Popup -->
<div class="modal fade zoomIn show confirmmodel" tabindex="-1" style="display: none; background: rgba(0,0,0,0.6);">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Finalize Session?</h5>
                <button type="button" class="btn-close" (click)="confirmno()"></button>
            </div>
            <div class="modal-body text-center">
                <p  style="font-weight: 600;">Are you sure you want to end this chat?</p>
            </div>
            <div class="modal-footer">
                <button class="modal-btn-cancel mr-2" (click)="confirmno()">Cancel</button>
                <button class="btn btn-danger" style="border-radius: 14px; padding: 12px 28px; font-weight: 700;" (click)="endChat()">Yes, End Session</button>
            </div>
        </div>
    </div>
</div>

<!-- Claim Customer Modal -->
<!-- <div class="modal fade zoomIn show claimModel" tabindex="-1" style="display: none; background: rgba(0,0,0,0.6);">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Claim Customer?</h5>
                <button type="button" class="btn-close" (click)="closeClaimModal()"></button>
            </div>
            <div class="modal-body text-center">
                <p style="font-weight: 600;">Are you sure you want to assign this customer to yourself?</p>
            </div>
            <div class="modal-footer">
                <button class="modal-btn-cancel mr-2" (click)="closeClaimModal()">Cancel</button>
                <button class="modal-btn-confirm" (click)="confirmAssignCustomer()">Yes, Claim</button>
            </div>
        </div>
    </div>
</div> -->

<!-- Unassign Customer Modal -->
<!-- <div class="modal fade zoomIn show unassignModel" tabindex="-1" style="display: none; background: rgba(0,0,0,0.6);">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Unassign Customer?</h5>
                <button type="button" class="btn-close" (click)="closeUnassignModal()"></button>
            </div>
            <div class="modal-body text-center">
                <p style="font-weight: 600;">Are you sure you want to remove yourself as the assigned teller for this customer?</p>
            </div>
            <div class="modal-footer">
                <button class="modal-btn-cancel mr-2" (click)="closeUnassignModal()">Cancel</button>
                <button class="btn btn-danger" style="border-radius: 14px; padding: 12px 28px; font-weight: 700;" (click)="confirmUnassignCustomer()">Yes, Unassign</button>
            </div>
        </div>
    </div>
</div> -->

<!-- Date Picker Modal -->
<div class="modal fade zoomIn show DatepickerModel" tabindex="-1" style="display: none; background: rgba(0,0,0,0.6);">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Snooze Conversation</h5>
                <button type="button" class="btn-close" (click)="confirmsnoozeno()"></button>
            </div>
            <div class="modal-body">
                <label class="form-label" style="font-weight: 800; color: #94A3B8; font-size: 11px; text-transform: uppercase; letter-spacing: 0.05em; margin-bottom: 12px; display: block;">Snooze Until</label>
                <div class="snooze-input-container" [ngClass]="{'border-danger': !snoozepickeddatetime && snoozeTouched}" (click)="snoozeTouched = true">
                    <i class="fa fa-calendar"></i>
                    <input type="text" id="selctedsnoozeata" placeholder="Select Date & Time" readonly [(ngModel)]="snoozepickeddatetime" name="snoozepickeddatetime">
                </div>
                <div *ngIf="!snoozepickeddatetime && snoozeTouched" class="text-danger mt-2" style="font-size: 11px; font-weight: 700;">
                    <i class="fa fa-exclamation-circle mr-1"></i> Please select a valid date and time.
                </div>
            </div>
            <div class="modal-footer">
                <button class="modal-btn-cancel mr-2" (click)="confirmsnoozeno()">Cancel</button>
                <button class="modal-btn-confirm" (click)="submitpck()" [disabled]="!snoozepickeddatetime">Confirm Snooze</button>
            </div>
        </div>
    </div>
</div>

<!-- Remove Snooze Modal -->
<div class="modal fade zoomIn show confirmRemoveSnooze" tabindex="-1" style="display: none; background: rgba(0,0,0,0.6);">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-body text-center">
                <h5 class="mb-4" style="font-weight: 800;">Remove this snooze?</h5>
                <div class="hstack gap-3 justify-content-center">
                    <button class="btn btn-light" style="border-radius: 12px; font-weight: 700;" (click)="confirmRemoveSnoozeno()">Cancel</button>
                    <button class="btn btn-danger" style="border-radius: 12px; font-weight: 700;" (click)="confirmRemoveSnoozeyes()">Remove</button>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Idle / Timeout Modal -->
<div class="modal fade zoomIn show" id="idlemodel" tabindex="-1" style="display: none; background: rgba(0,0,0,0.6);">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Inactivity Log Out</h5>
            </div>
            <div class="modal-body text-center">
                <i class="fa fa-clock-o mb-4" style="font-size: 50px; color: #6366F1; opacity: 0.5;"></i>
                <h4 class="fs-semibold mb-3">{{idleState}}</h4>
                <p class="text-muted" style="font-size: 13px; line-height: 1.6;">For your security, sessions automatically end after a period of inactivity.</p>
            </div>
            <div class="modal-footer">
                <button class="modal-btn-cancel mr-2" (click)="idleLogout()">Log Out</button>
                <button class="modal-btn-confirm" (click)="stay()">Stay Logged In</button>
            </div>
        </div>
    </div>
</div>

<!-- Session Conflict Modal -->
<div class="modal fade zoomIn show alreadymodel" tabindex="-1" style="display: none; background: rgba(0,0,0,0.6);">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Unable to Send Message</h5>
                <button type="button" class="btn-close" (click)="endalready()"></button>
            </div>
            <div class="modal-body text-center">
                <div class="mb-4">
                    <i class="fa fa-info-circle" style="font-size: 40px; color: #1877F2; opacity: 0.3;"></i>
                </div>
                <p style="font-weight: 600; line-height: 1.6;">Messages cannot be sent to this customer at the moment.</p>
                <p class="text-muted" style="font-size: 13px; margin-top: 10px;">Please try again later.</p>
            </div>
            <div class="modal-footer">
                <button class="modal-btn-confirm" (click)="endalready()">Ok, Got it</button>
            </div>
        </div>
    </div>
</div>